export const PERMISSIONS = {
  REGION: 'region',
  PROVINCE: 'province',
  REPUBLIC: 'republic',
  MARKET: 'market',
  MARKET_REP: 'market_rep',
  AGROTECH_REP: 'agrotech_rep_harvesting',
  AGROTECH: 'agrotech_harvesting',
  AGROTECH_PROV_HARVESTING: 'agrotech_prov_harvesting',
  AGROTECH_COTTON_REP: 'agrotech_rep_cot',
  AGROTECH_COTTON: 'agrotech_cot',
  AGROTECH_COTTON_PROV: 'agrotech_prov_cot',
  AGROTECH_PLANT_PROV: 'agrotech_prov_plant',
  AGROTECH_PLANT: 'agrotech_plant',
  AGROTECH_PLANT_REP: 'agrotech_rep_plant',

  AGROCULT_CROP_REP: 'agrocult_rep_agro_crop',
  AGROCULT_CROP: 'agrocult_agro_crop',
  AGROCULT_CROP_PROV: 'agrocult_prov_agro_crop',

  AGROCULT_POULTRY_REP: 'agrocult_rep_poultry',
  AGROCULT_POULTRY: 'agrocult_poultry',
  AGROCULT_POULTRY_PROV: 'agrocult_prov_poultry',

  AGROTECH_MUL_PROV: 'agrotech_prov_mul',
  AGROTECH_MUL: 'agrotech_mul',
  AGROTECH_MUL_REP: 'agrotech_rep_mul',
  COTTON_REGION: 'cotton',
  COTTON_PROV: 'cotton_prov',
  COTTON_REP: 'cotton_rep',

  ANIMAL_PROV: 'animal_prov',
  ANIMAL: 'animal',
  ANIMAL_REP: 'animal_rep',
  WATER_PROV: 'water_prov',
  WATER: 'water',
  WATER_REP: 'water_rep',
  WOOL_PROV: 'wool_prov',
  WOOL: 'wool',
  WOOL_REP: 'wool_rep',
  HONEY_PROV: 'honey_prov',
  HONEY: 'honey',
  HONEY_REP: 'honey_rep',
  STAT: 'stat',
  STAT_PROV: 'stat_prov',
  STAT_REP: 'stat_rep',
};
